import { render, staticRenderFns } from "./emailDetils.vue?vue&type=template&id=35063f8c&scoped=true&"
import script from "./emailDetils.vue?vue&type=script&lang=js&"
export * from "./emailDetils.vue?vue&type=script&lang=js&"
import style0 from "./emailDetils.vue?vue&type=style&index=0&id=35063f8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35063f8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35063f8c')) {
      api.createRecord('35063f8c', component.options)
    } else {
      api.reload('35063f8c', component.options)
    }
    module.hot.accept("./emailDetils.vue?vue&type=template&id=35063f8c&scoped=true&", function () {
      api.rerender('35063f8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/email/components/emailDetils.vue"
export default component.exports